import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import winefoPublicApi from './winefo-public-api';
import { DocumentLocationView } from '../../api';

export const DOCUMENT_LOCATIONS = 'document-locations';

const useGetLegalDocuments = (
  type: 'PP' | 'TNC',
  options?: UseQueryOptions<
    DocumentLocationView,
    unknown,
    DocumentLocationView,
    (string | number | undefined)[]
  >
): UseQueryResult<DocumentLocationView, unknown> => {
  return useQuery({
    queryKey: [DOCUMENT_LOCATIONS, type],
    queryFn: () =>
      winefoPublicApi.getDocumentLocations(type).then((result) => result.data),
    ...options,
  });
};

export default useGetLegalDocuments;
